export const FILE_UPLOAD_RESPONSE_CONSTANTS = {
  RESULTS: $localize`Results`,
  FILE_SIZE: $localize`File Size`,
  FILE_NAME: $localize`File Name`,
  UNIQUE_ID: $localize`Unique device name for upload`,
  ROWS: $localize`Number of rows in uploaded file`,
  RECORDS_ACCEPTED: $localize`Records Accepted`,
  RECORDS_REJECTED: $localize`Records Rejected`,
  INVALID_ITEMS: $localize`Invalid Items`,
  NON_PROCESSED: $localize`Non Processed`,
  ERROR_RECORDS_REJECTED: $localize`Rejected Rows:`,
  ERROR_RECORDS_NON_PROCESSED: $localize`Non Processed Rows:`,
};
